/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getPostThread.defs.js'
export { main as default } from './getPostThread.defs.js'
